"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideoIndex = void 0;
const immutable_1 = require("immutable");
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const adAnalyticsVideoIndexKeyFrame_1 = require("./adAnalyticsVideoIndexKeyFrame");
const adAnalyticsVideoIndexKeyword_1 = require("./adAnalyticsVideoIndexKeyword");
const adAnalyticsVideoIndexWatchingRating_1 = require("./adAnalyticsVideoIndexWatchingRating");
const timeObject_1 = require("./timeObject");
const createSomeAdAnalyticsVideoIndex = ({ keywords = immutable_1.List([
    adAnalyticsVideoIndexKeyword_1.createSomeAdAnalyticsVideoIndexKeyword({ text: 'キーワード' }),
    adAnalyticsVideoIndexKeyword_1.createSomeAdAnalyticsVideoIndexKeyword({ text: 'キーワード2' }),
]), keyFrames = immutable_1.List([
    adAnalyticsVideoIndexKeyFrame_1.createSomeAdAnalyticsVideoIndexKeyFrame({
        thumbnailImageUrl: 'http://placehold.it/400x300',
        start: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 10 }),
        end: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 20 }),
    }),
    adAnalyticsVideoIndexKeyFrame_1.createSomeAdAnalyticsVideoIndexKeyFrame({
        thumbnailImageUrl: 'http://placehold.it/400x300',
        start: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 15 }),
        end: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 30 }),
    }),
]), watchingRatings = immutable_1.List([
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 0, rate: 0 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 10, rate: 15 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 20, rate: 20 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 30, rate: 40 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 40, rate: 60 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 50, rate: 80 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 60, rate: 90 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 70, rate: 60 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 80, rate: 30 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 90, rate: 20 }),
    adAnalyticsVideoIndexWatchingRating_1.createSomeAdAnalyticsVideoIndexWatchingRating({ until: 100, rate: 5 }),
]), } = {}) => new AdAnalyticsVideo_1.AdAnalyticsVideoIndex({
    keywords,
    keyFrames,
    watchingRatings,
});
exports.createSomeAdAnalyticsVideoIndex = createSomeAdAnalyticsVideoIndex;
